/* eslint-disable */

export function saveToSessionStorage(key: string, data: any): void {
    sessionStorage.setItem(key, JSON.stringify(data));
}

export function getFromSessionStorage<T = any>(key: string): T | null {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
}

export function removeFromSessionStorage(key: string): void {
    sessionStorage.removeItem(key);
}
